import styled from 'styled-components';

export const NewsletterSectionWrapper = styled.div<{emailInputError: boolean | undefined}>`
    ${(p) => p.theme.breakpoints.up('md')} {
        .newsletter-section-description-small {
            text-align: left;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:focus {
        transition: background-color 600000s 0s, color 600000s 0s;

        -webkit-box-shadow: unset;
        -webkit-text-fill-color: unset;
    }

    position: relative;
    text-align: center;

    &.small {
        text-align: left;
    }

    && .paragraph {
        color: ${(p) => p.theme.palette.common.black};
    }

    .newsletter-section-input {
        & > div {
            background: ${(p) => p.theme.palette.neutral.chalk};
        }

        & > .Mui-focused:not(.Mui-error) {
            outline: 1px solid ${(p) => p.theme.palette.neutral.charcoal};
        }
    }

    .newsletter-section-select {
        &.Mui-focused:not(.Mui-error) > div:focus-visible {
            outline: 1px solid ${(p) => p.theme.palette.neutral.charcoal};
        }
    }

    .button-grid-item {
        z-index: 1;
        ${(p) => p.theme.breakpoints.down('sm')} {
            margin-top: 14px;
        }

        .ue-link-wrap-span {
            .ue-outlined:focus-visible {
                outline: 1px solid ${(p) => p.theme.palette.neutral.charcoal};
            }
        }
    }

    button.primary {
        width: 100%;
        min-width: 132px;
    }

    input::placeholder {
        color: ${(p) => p.theme.palette.neutral.charcoal};
    }

    .newsletter-grid {
        position: relative;
        z-index: 10;
    }

    .ue-icon-check {
        font-size: 42px;
    }

    &.twinmotion {
        .newsletter-section-input-grid-container {
            background: transparent;

            ${(p) => p.theme.breakpoints.up('md')} {
                .MuiGrid-grid-md-8 {
                    padding-right: ${(p) => `${p.theme.spacing(2)}px`};
                }
            }
        }

        .newsletter-section-input {
            background: ${(p) => (p.emailInputError ? 'unset' : p.theme.palette.neutral.chalk)};
            border-radius: 90px;
            margin-right: 8px;
            width: calc(100% - 8px);
            & > div {
                border-radius: 90px;
            }
        }
    }

    .privacypolicy-grid-item {
        align-self: center;
        margin-left: 15px;
        ${(p) => p.theme.breakpoints.down('sm')} {
            margin-top: 24px;
        }
    }
`;

export const NewsletterSectionInner = styled.div`
    position: relative;
    z-index: 10;
    background: ${(p) => p.theme.palette.common.white};
    color: ${(p) => p.theme.palette.neutral.charcoal};
    padding: ${(p) => `${p.theme.spacing(9)}px`} 0;

    ${(p) => p.theme.breakpoints.down('sm')} {
        padding: ${(p) => `${p.theme.spacing(7)}px`} 0;
    }

    &.small {
        text-align: center;
        ${(p) => p.theme.breakpoints.up('sm')} {
            padding: ${(p) => `${p.theme.spacing(6)}px`} 0;
            display: flex;
            flex-direction: column;
            .heading {
                width: unset;
                min-width: unset;
                flex: 4;
            }
            .paragraph {
                width: unset;
                min-width: unset;
                flex: 1;
            }
        }
    }
`;

export const NewsletterSectionBackground = styled.div`
    position: absolute;
    top: 50%;
    bottom: 0;
    left: 0;
    right: 0;

    /* must match the footer background */
    background-color: ${(p) => p.theme.palette.neutral.concrete};
    &.twinmotion {
        background-color: ${(p) => p.theme.palette.neutral.carbon};
    }
`;
